import adformIcon from 'assets/channels/adform.svg';
import adfoxIcon from 'assets/channels/adfox.svg';
import adriverIcon from 'assets/channels/adriver.svg';
import begunIcon from 'assets/channels/begun.svg';
import customIcon from 'assets/channels/custom.svg';
import facebookIcon from 'assets/channels/facebook.svg';
import googleIcon from 'assets/channels/google.svg';
import googledbmIcon from 'assets/channels/googledbm.svg';
import googledcmIcon from 'assets/channels/googledcm.svg';
import ozonIcon from 'assets/channels/ozon.svg';
import rbmailIcon from 'assets/channels/rbmail.svg';
import targetmailIcon from 'assets/channels/targetmail.svg';
import twitterIcon from 'assets/channels/twitter.svg';
import tiktokIcon from 'assets/channels/tiktok.svg';
import vkontakteIcon from 'assets/channels/vkontakte.svg';
import weboramaIcon from 'assets/channels/weborama.svg';
import yandexIcon from 'assets/channels/yandex.svg';
import yandexaudienceIcon from 'assets/channels/yandexaudience.svg';
import yandexdisplayIcon from 'assets/channels/yandexdisplay.svg';
import yandexmarketIcon from 'assets/channels/yandexmarket.svg';
import youtubeIcon from 'assets/channels/youtube.svg';
import wildberriesIcon from 'assets/channels/wildberries.svg';
import vkadsIcon from 'assets/channels/vkads.svg';
import uniqBy from 'lodash.uniqby';
import {AbstractService} from 'services/AbstractService';
import store from 'store';


const CHANNELS_API_URL = '/api/channels';
const ACCOUNT_CHANNELS_URL = '/api/accounts/channels';


const channelIconMap = {
  adform: adformIcon,
  adfox: adfoxIcon,
  adriver: adriverIcon,
  begun: begunIcon,
  custom: customIcon,
  facebook: facebookIcon,
  googledbm: googledbmIcon,
  googledcm: googledcmIcon,
  google: googleIcon,
  ozon: ozonIcon,
  ozonseller: ozonIcon,
  rbmail: rbmailIcon,
  targetmail: targetmailIcon,
  twitter: twitterIcon,
  tiktok: tiktokIcon,
  vkontakte: vkontakteIcon,
  weborama: weboramaIcon,
  yandexaudience: yandexaudienceIcon,
  yandexdisplay: yandexdisplayIcon,
  yandexmarket: yandexmarketIcon,
  yandex: yandexIcon,
  youtube: youtubeIcon,
  wildberries: wildberriesIcon,
  vkads: vkadsIcon
};

export class ChannelsService extends AbstractService {
  convertChannel (channel) {
    return {
      id: channel.id,
      name: channel.display_name,
      icon: channelIconMap[channel.name],
      internalName: channel.name,
      hasPlan: channel.has_plan,
      hasFact: channel.has_fact
    };
  }

  getIconByChannelName (channelName) {
    return channelIconMap[channelName];
  }

  // some channels may be disabled in application but referenced in code
  getIconFromEnabledChannel (channelName) {
    const enabledChannel = store.getters['channels/getEnabledChannelByName'](channelName);
    if (!enabledChannel) {
      return;
    }
    return channelIconMap[enabledChannel.name];
  }

  async getChannelsList () {
    return (await this.client.get(CHANNELS_API_URL)).items;
  }

  async getAccountsChannelsList (accountIds) {
    return (await this.client.get(ACCOUNT_CHANNELS_URL, {account_id: accountIds})).items;
  }

  async getProjectChannels (placementsList) {
    let channelsList = await this.getChannelsList();

    const placementChannelsIds = uniqBy(placementsList.map(i => i.channel_id));
    channelsList = channelsList.filter(i => placementChannelsIds.includes(i.id));
    return channelsList.map(i => this.convertChannel(i));
  }

  async getAccountChannels (accountIds) {
    let accountIdsArray = Array.isArray(accountIds) ? accountIds : [accountIds];
    return (await this.getAccountsChannelsList(accountIdsArray)).map(i => this.convertChannel(i));
  }

  filterChannelsWithFact (channelsList) {
    return channelsList.filter(channel => channel.hasFact);
  }
}
